// extracted by mini-css-extract-plugin
module.exports = {"noMarginBottom":"blog-post-module--noMarginBottom--1kQHI","tweetBox":"blog-post-module--tweetBox--Ybun0","HeaderImage":"blog-post-module--HeaderImage--1g_Tp"};